import React from 'react';
import AlertBox from 'components/shared/AlertBox';
import { Button } from 'ui';

const ErrorModal = () => (
  <AlertBox className="Editor-ErrorModal ta-c">
    <img
      src="/assets/blankslates/editor_error.svg"
      role="presentation"
      alt={t('lessons.editor.error_message')}
    />
    <h3>{t('common.uh_oh')}</h3>
    <p>
      {t('common.problem.saving_update')}
      <br />
      {t('common.solution.reload_try_again')}
    </p>
    <Button onClick={() => window.location.reload()}>
      {t('common.reload_page')}
    </Button>
  </AlertBox>
);

export default ErrorModal;
